export const _en = {
    addButton: {
        label: "Add a timetable",
        tooltip: "Add a timetable"
    },
    dialog: {
        add: {
            title: "Add a timetable",
            buttons: {
                save: "Save",
                cancel: "Cancel"
            }
        },
        duplication: {
            title: "Duplication of a timetable",
            message: "You are about to duplicate a timetable : "
        }
    },
    accordion: {
        info: {
            label: "General data"
        }
    }
};


export const _fr = {
    addButton: {
        label: "Grille horaire",
        tooltip: "Ajouter une grille horaire"
    },
    dialog: {
        add: {
            title: "Ajout d'une grille horaire",
            buttons: {
                save: "Sauvegarder",
                cancel: "Annuler"
            }
        },
        duplication: {
            title: "Duplication d'une grille horaire",
            message: "Vous allez dupliquer la grille horaire : "
        }
    },
    accordion: {
        info: {
            label: "Informations générales"
        }
    },
    columns: {
        weekNumber: {
            label: "Nombre de semaines"
        },
        workedHoursCount: {
            label: "Nombre d'heures"
        }
    },
    newWeek: {
        label: "Nouvelle"
    }

};